import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { ControltowerService } from 'src/app/services/dashboards/controltower.service';
import { GridServiceService } from 'src/app/services/shared/grid-service.service';
import { GridColumnsConfiguration, GridFilter } from '../../shared/grid/grid.component';

import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PropertiesTowers } from 'src/app/services/dashboards/propertiesTower.service';
import { LoginService } from 'src/app/services/security/login.service';

export interface DemoData {
  id: number,
  nombre: string,
  status: string
}

@Component({
  selector: 'neoris-status-cctv',
  templateUrl: './status-cctv.component.html',
  styleUrls: ['./status-cctv.component.css']
})
export class StatusCctvComponent implements OnInit, OnDestroy {

  public gridTitle: string = 'STATUS_CCTV_SUB_TITLE'
  private lang: string = "en";
  private siteId: string = ""
  gridData: any = []

  public gridColumnsConfiguration: GridColumnsConfiguration = {
    IconValue: "summary",
    IconColumnName: "summary",
    hiddenColumnNames: [  'devices',
                          'id',
                          'addressId',
                          'siteRegionId',
                          'siteTypeId',
                          'ROW_ID'],
    dateColumns: [],
    cardColum: "name",
    cardValues: [
      { place: 0, nombre: 'name', isMainColumn: false },
      { place: 0, nombre: 'code', isMainColumn: false },
      { place: 0, nombre: 'camerasConnected', isMainColumn: false },
      { place: 0, nombre: 'pcsConnected', isMainColumn: false },
      { place: 0, nombre: 'visibility', isMainColumn: false },
      { place: 0, nombre: 'summary', isMainColumn: true },
    ],
    MultiIconColumns: [
      ],
    ActionColumn: {
      ColumnName: "",
      Actions: [
      ]
    }
  }

  public statusCCTVModel: {
    cameras: number,
    camerasConnected: number,
    camerasConnectedPercentage: number,
    pcs: number,
    pcsConnected: number,
    pcsConnectedPercentage: number,
    summary: number,
    visibility: number
  } = {
    cameras: 0,
    camerasConnected: 0,
    camerasConnectedPercentage: 0,
    pcs: 0,
    pcsConnected: 0,
    pcsConnectedPercentage: 0,
    summary: 0,
    visibility: 0,
  }

  private onLanChange: Subscription

  public activeFilter: number = -1;
  public gFilter: GridFilter = undefined;
  private onIsAllSitesSubscription:Subscription

  constructor(private gridServiceService: GridServiceService,
    private controltowerservice: ControltowerService,private route: Router 
    ,private translate: TranslateService,private propertiesService:PropertiesTowers,
    private securityService: LoginService) {

    
    this.onLanChange = this.translate.onLangChange.subscribe(s => {
      this.lang = s.lang
      this.getDeviceManagementInfo(this.lang)
    })
    
   
  }

  async ngOnInit():  Promise<void> {

    const userName = JSON.parse(localStorage.getItem('ud'))[1].value
    const guid = JSON.parse(localStorage.getItem('guidSession'))
    const response = await this.securityService.login(userName,guid).toPromise()



    this.siteId = localStorage.getItem('site');
    console.log('esto son los ids1----------->',this.siteId)
    this.getDeviceManagementInfo(this.lang)

    this.onIsAllSitesSubscription =this.propertiesService.IsSelectAllSites$.subscribe((value) =>{
      console.log('si escuche refresh------>')
      console.log('esto son los ids2----------->',this.siteId)
      this.siteId = localStorage.getItem('site');
      this.getDeviceManagementInfo(this.lang)
  
    
    })
  }


  ngOnDestroy(): void {
    this.onLanChange.unsubscribe()
    this.onIsAllSitesSubscription.unsubscribe()
  }

  
  async searchButtonClick() {
  }

  public GetSelectedData() {
    this.gridServiceService.requestSelectedRows()
  }


  private async getDeviceManagementInfo(lang): Promise<boolean> {

    console.log('entre al grid')
    return new Promise<boolean>((resolve, reject) => {

      this.controltowerservice.getDeviceManagement(lang, this.siteId).subscribe(
        {
          next: (managementInfo: any) => {

            let sites: any = []
            this.statusCCTVModel.cameras = managementInfo.cameras
            this.statusCCTVModel.camerasConnected  = managementInfo.camerasConnected
            this.statusCCTVModel.camerasConnectedPercentage = (managementInfo.camerasConnectedPercentage == undefined ? 0 : managementInfo.camerasConnectedPercentage)

            this.statusCCTVModel.pcs = managementInfo.pcs
            this.statusCCTVModel.pcsConnected = managementInfo.pcsConnected
            this.statusCCTVModel.pcsConnectedPercentage = (managementInfo.pcsConnectedPercentage == undefined ? 0 : managementInfo.pcsConnectedPercentage)
            
            this.statusCCTVModel.visibility  = managementInfo.visibility

            this.statusCCTVModel.summary  = managementInfo.summary

            managementInfo.sites.forEach(item => {
              const _site = {
                id: item.site.id,
                name: item.site.name,
                code: item.site.code,
                addressId: item.site.addressId,
                siteRegionId: item.site.siteRegionId,
                siteTypeId: item.site.siteTypeId,
                cameras: item.cameras,
                camerasConnected: (item.camerasConnectedPercentage == undefined ? 0 : item.camerasConnectedPercentage) + '%',
                pcs: item.pcs,
                pcsConnected: (item.pcsConnectedPercentage == undefined ? 0 : item.pcsConnectedPercentage) + '%',
                visibility: item.visibility,
                summary: item.summary.toString().toLowerCase(),
                devices: item.devices
              }
              sites.push(_site)
            });

            sites = sites.map((device, index) => ({
              ...device,
              ROW_ID: index + 1,
            }));

            this.gridData = sites;
           
            resolve(true);
          }, error: (error: HttpErrorResponse) => {
            resolve(false);
          }
        }
      )
    });
  }

  public cellClick(obj: any) {

    localStorage.setItem('rowSelectEventCctv',JSON.stringify(obj))
    this.route.navigate(['/device-management'])
  }

  public cardClick(filter: number){

    if(this.activeFilter == filter){
      this.activeFilter = -1
    }else{
      this.activeFilter = filter
    }

    this.filterGridFromCardSelected(this.activeFilter)
  }

  private filterGridFromCardSelected(activeFilter: number){
    let filter: string = ''

    if(activeFilter >= 0){
      filter = activeFilter.toString()
    }


    const gridFilter: GridFilter = {
      importance: 1,
      column: "incidentTypeId",
      filter_one: filter,
      isFilterDates: false,
      isExternalFilter: true
    }

    console.log("gridFilter", gridFilter)

    this.gFilter = gridFilter
  }

}
